window.injectJs = function(jsSrc) {
    return new Promise((resolve, reject) => {
        let js = document.createElement('script');
        js.src = jsSrc;
        js.onload = resolve;
        js.onerror = reject;
        document.head.appendChild(js);
    });
};

window.injectCss = function(cssHref) {
    return new Promise((resolve, reject) => {
        let css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = cssHref;
        css.onload = resolve;
        css.onerror = reject;
        document.head.appendChild(css);
    });
};